import { useEffect } from "react";
import { useNavigate, Routes, Route } from "react-router-dom";
import Sidebar from "./Sidebar";
import DashboardOverview from "./DashboardOverview";
import BookingsManagement from "./BookingsManagement";
import InquiriesManagement from "./InquiriesManagement";
import PackagesManagement from "./PackagesManagement";
import MenuItemsManagement from "./MenuItemsManagement";
import GalleryManagement from "./GalleryManagement";
import TestimonialsManagement from "./TestimonialsManagement";
import AvailabilityManagement from "./AvailabilityManagement";

const AdminDashboard = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const isLoggedIn = sessionStorage.getItem("adminLoggedIn");
    if (!isLoggedIn) {
      navigate("/admin");
    }
  }, [navigate]);

  return (
    <div className="min-h-screen bg-[#F4F1DE]">
      <Sidebar />
      <main className="ml-64 p-8" data-testid="admin-main-content">
        <Routes>
          <Route path="/" element={<DashboardOverview />} />
          <Route path="/bookings" element={<BookingsManagement />} />
          <Route path="/inquiries" element={<InquiriesManagement />} />
          <Route path="/packages" element={<PackagesManagement />} />
          <Route path="/menu-items" element={<MenuItemsManagement />} />
          <Route path="/gallery" element={<GalleryManagement />} />
          <Route path="/availability" element={<AvailabilityManagement />} />
          <Route path="/testimonials" element={<TestimonialsManagement />} />
        </Routes>
      </main>
    </div>
  );
};

export default AdminDashboard;
